import { ROLES } from 'dashboard/constants/permissions';
import { frontendURL } from '../../../helper/URLHelper';
import ModuleFrame from './ModuleFrame.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/custom-modules/:moduleId'),
    name: 'custom_module_show',
    component: ModuleFrame,
    meta: {
      permissions: [...ROLES],
    },
  },
];
